import React, { FC } from 'react';
import Text from '../Text';
import * as PaginationStyles from './_pagination.module.scss';
import { LuChevronsLeft, LuChevronLeft, LuChevronRight, LuChevronsRight } from 'react-icons/lu';

type PaginationProps = {
    currentPage: number;
    maxPage: number;
    onNext: () => void;
    onPrev: () => void;
    onFirst: () => void;
    onLast: () => void;
}

const Pagination: FC<PaginationProps> = ({
    currentPage,
    maxPage,
    onNext,
    onPrev,
    onFirst,
    onLast,
}) => {
    return (
        <div className={PaginationStyles.container}>
            <button
                type='button'
                onClick={onFirst}
            >
                <LuChevronsLeft size={25} />
            </button>

            <button
                type='button'
                onClick={onPrev}
            >
                <LuChevronLeft size={25} />
            </button>

            <Text label={`Page ${currentPage + 1} of ${Math.max(maxPage + 1, 1)}`} />

            <button
                type='button'
                onClick={onNext}
            >
                <LuChevronRight size={25} />
            </button>

            <button
                type='button'
                onClick={onLast}
            >
                <LuChevronsRight size={25} />
            </button>
        </div>
    );
};

export default Pagination;
